import React from 'react';
import { MdCheck, MdFileCopy } from "react-icons/md";
import {
  Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow,
} from "@chakra-ui/react";
import { Portal } from "@chakra-ui/portal";

const ShortTruncateCopy = React.forwardRef<HTMLDivElement, {
  info: string;
  slice?: number;
  showCopy?: boolean;
}>(({ info, slice = 50, showCopy }, ref) => {
  const [copy, setCopy] = React.useState(false);
  const truncatedText = info?.length > slice ? info.substring(0, slice) + "..." : info;
    const isMobile = window.innerWidth < 768;

  return (
    <div ref={ref} className="stc-wrap">  {/* ← attach ref here */}
        <Popover trigger={isMobile ? "click" : "hover"} placement="bottom-start">
            <PopoverTrigger>
                <span
                className="stc-text"
                style={{ cursor: info.length > slice ? "pointer" : "default" }}
                >
                {truncatedText}
                </span>
            </PopoverTrigger>

            {info.length > slice && (
                <PopoverContent
                    border="1px solid #bfdbfe"
                    borderRadius="12px"
                    bg="#eff6ff"
                    maxW="calc(100vw - 32px)"
                    width="auto"
                    p="12px"
                    zIndex={20}
                    >
                    <PopoverArrow />
                    <div
                        style={{
                        fontSize: "12px",
                        color: "#1e293b",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                        whiteSpace: "normal",
                        lineHeight: "1.5",
                        }}
                    >
                        {info}
                    </div>
                    </PopoverContent>
            )}
        </Popover>
      
      {showCopy && (
        copy ? (
          <MdCheck className="stc-icon stc-icon--done" />
        ) : (
          <MdFileCopy
            className="stc-icon"
            onClick={() => {
              navigator.clipboard.writeText(info);
              setCopy(true);
              setTimeout(() => setCopy(false), 1500);
            }}
          />
        )
      )}
      <style>{`
        .stc-wrap {
          display: flex;
          align-items: center;
          gap: 6px;
          min-width: 0;        /* allow shrinking inside any flex parent */
          max-width: 100%;
        }
        .stc-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 0;
          flex: 1 1 0%;        /* grow + shrink from 0 base */
        }
        .stc-icon {
          flex-shrink: 0;      /* icon never squishes */
          cursor: pointer;
          color: #14b8a6;
          font-size: 15px;
        }
        .stc-icon--done {
          cursor: not-allowed;
          color: #14b8a6;
        }

        /* On narrow screens reduce font slightly */
        @media (max-width: 480px) {
          .stc-text { font-size: 12px; }
          .stc-icon { font-size: 14px; }
        }
      `}</style>
    </div>
  );
});

ShortTruncateCopy.displayName = "ShortTruncateCopy";
export default ShortTruncateCopy;